import classNames from "classnames";
import { AlertProps } from "./Alert.types";

/** A Bootstrap alert with an optional bold title, over its children or a line of text. */
export function Alert({
  variant = "danger",
  title,
  text,
  className = "my-3",
  children,
}: AlertProps) {
  return (
    <div className={classNames("alert", `alert-${variant}`, className)} role="alert">
      {title && (
        <p>
          <strong>{title}</strong>
        </p>
      )}
      {children ?? <p className="mb-0">{text}</p>}
    </div>
  );
}

export default Alert;
